import { useAppStore } from '@/stores/app'
import type { ECountry } from '@/shared/enum/country.enum'
import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'
import getCurrentCountry from '@/shared/utils/get-current-country'

export const useI18n = () => {
  const country: ECountry = getCurrentCountry()
  const appStore = useAppStore()

  const setCountryInStore = () => {
    appStore.setCountry(country)

    localStorage.setItem(ELocalStorageKey.I18N, country)
  }

  return {
    country,
    setCountryInStore
  }
}
